import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { stateOptionsFullNames } from "data";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function AgencyDocumentsModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    files: Yup.mixed().required("This field is required!"),
  });

  const options = [
    {
      value: "w9",
      label: "W-9",
    },
    {
      value: "agency_contract",
      label: "Agency Contract",
    },
    {
      value: "license",
      label: "License",
    },
    {
      value: "eo",
      label: "E&O",
    },
  ];

  return (
    <Fragment>
      {modal.name === "agency_document_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add Document</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  files: "",
                  type: options[0].value,
                  state: "",
                  expiration_date: "",
                }}
                onSubmit={async (values, { setErrors }) => {
                  const { type, expiration_date, state } = values;

                  const errors = {};

                  if (values.type === "license" && values.state === "") {
                    errors.state = "Invalid state";
                  }

                  if (
                    (values.type === "eo" || values.type === "license") &&
                    (!values.expiration_date ||
                      new Date(values.expiration_date).getTime() <=
                        new Date().getTime())
                  ) {
                    errors.expiration_date = "Invalid date";
                  }

                  if (errors.state || errors.expiration_date) {
                    setErrors(errors);

                    return;
                  }

                  setLoading(true);

                  const files = document.getElementById("file").files;

                  for (var i = 0; i < files.length; i++) {
                    await axios
                      .post(`/api/document`, {
                        name: files[i].name,
                        type,
                        expiration_date,
                        state,
                        account_id: modal.data.agency_id,
                        status: "pending_review",
                      })
                      .then(async (res) => {
                        const form_data = new FormData();
                        form_data.append("file", files[i]);

                        await axios
                          .post(
                            `/api/document/${res.data.data.id}/file`,
                            form_data,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                          .then(() => {
                            context.notification.show(
                              "Document created successfully!",
                              "success",
                              true,
                              "toast",
                              "check-circle"
                            );

                            modal.action();
                          })
                          .catch((fileErr) => {
                            console.log(fileErr);

                            context.notification.show(
                              fileErr.response.data.message
                                ? fileErr.response.data.message
                                : "Failed on upload file to server.",
                              "error",
                              true,
                              "toast",
                              "x-circle"
                            );
                          });
                      })
                      .catch((err) => {
                        setLoading(false);
                        setModal({});

                        context.notification.show(
                          err.response.data.message,
                          "error",
                          true,
                          "toast",
                          "x-circle"
                        );
                      });
                  }

                  setLoading(false);
                  setModal({});
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                  setFieldValue,
                  values,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div
                        className={styles.fieldRow}
                        style={{ paddingBottom: 0 }}
                      >
                        <FieldInput
                          id="type"
                          type="select"
                          label="Type"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          options={options}
                          showErrors
                          errors={errors.type}
                          touched={touched.type}
                        />
                      </div>
                      {values.type === "license" && (
                        <>
                          <div
                            className={styles.fieldRow}
                            style={{ paddingBottom: 0 }}
                          >
                            <FieldInput
                              id="state"
                              type="select"
                              label="State"
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              required
                              options={[
                                { value: "", label: "Select a state" },
                                ...stateOptionsFullNames,
                              ]}
                              showErrors
                              errors={errors.state}
                              touched={touched.state}
                            />
                            <FieldInput
                              id="expiration_date"
                              type="date"
                              label="Expiration Date"
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              required
                              options={options}
                              showErrors
                              errors={errors.expiration_date}
                              touched={touched.expiration_date}
                            />
                          </div>
                        </>
                      )}
                      {values.type === "eo" && (
                        <>
                          <div
                            className={styles.fieldRow}
                            style={{ paddingBottom: 0 }}
                          >
                            <FieldInput
                              id="expiration_date"
                              type="date"
                              label="Expiration Date"
                              handleChange={handleChange}
                              handleBlur={handleBlur}
                              required
                              options={options}
                              showErrors
                              errors={errors.expiration_date}
                              touched={touched.expiration_date}
                            />
                          </div>
                        </>
                      )}
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="file"
                          type="upload_multiple"
                          label="Files"
                          handleChange={(files) => {
                            handleChange("files");
                            setFieldValue("files", files);
                          }}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.files}
                          touched={touched.files}
                          required
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            !loading
                              ? { cursor: "pointer" }
                              : { cursor: "default" }
                          }
                        >
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            <>{modal.mode === "edit" ? "Update" : "Create"}</>
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
